import { Pipe, PipeTransform } from '@angular/core';
import { ArrayUtilities } from '@shared/utility';
import { SelectItem } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';

@Pipe({
    name: 'filterByFilteredCriteria',
    standalone: false
})
export class FilterByFilteredCriteriaPipe implements PipeTransform {

  transform(values: any[], filters: any, field: string, multySelect: MultiSelect): SelectItem[] {
    let res = [];
    const selectedValues = multySelect.value;
    if (!filters) {
      res = ArrayUtilities.arrayToSelectItemArrayByUniqueKey(values, field, false);
    } else {
      res = ArrayUtilities.arrayToSelectItemArrayByUniqueKey(filters, field, false);
    }
    if (selectedValues && selectedValues.length) {
      const resList = res.map(el => el.value);
      selectedValues.forEach(selectedValue => {
        if (resList.indexOf(selectedValue) === -1) {
          res.push({
            value: selectedValue,
            label: selectedValue
          });
        }
      });

    }
    return ArrayUtilities.sortSelectItems(res);
  }
}
